import FormInputTypes from '../../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appConfigs',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  canFilter:true,
  emptyMessage: "You don't have apps or rooms created. You must create one to get info here",
  fields: [
    {
      attributeName: 'appName',
      label: 'App/SportRoom',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'The app/room name.',
    },
    {
      attributeName: 'type',
      label: 'Type',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'The item type. It can be Room or App.',
    },
    {
      attributeName: 'configName',
      label: 'Config',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the config inside the room.',
    },
  ],
};
